export const COMBINED_INVENTORY_RESET = "COMBINED_INVENTORY_RESET";
export const COMBINED_INVENTORY_SEARCH = "COMBINED_INVENTORY_SEARCH";
export const COMBINED_INVENTORY_REQUEST = "COMBINED_INVENTORY_REQUEST";
export const COMBINED_INVENTORY_SUCCESS = "COMBINED_INVENTORY_SUCCESS";
export const COMBINED_INVENTORY_FAILURE = "COMBINED_INVENTORY_FAILURE";
export const COMBINED_INVENTORY_SET_QUERY = "COMBINED_INVENTORY_SET_QUERY";
export const COMBINED_INVENTORY_SET_FILTER = "COMBINED_INVENTORY_SET_FILTER";
